module.exports = __webpack_public_path__ + "img/tree-03-a-leaves.c171bee1.png";